import React  from 'react';
import { StyleSheet, View, ScrollView , Dimensions ,  Share , Image } from 'react-native';
import { Avatar , FAB, IconButton, Button , Appbar,Text,Card,Divider, Modal, Portal,TextInput,Snackbar } from 'react-native-paper';
import AnimatedProgressWheel from 'react-native-progress-wheel';
import { Rating } from 'react-native-ratings';
import { WebView } from 'react-native-web-webview';
import TextTicker from 'react-native-text-ticker';
import { SliderBox } from "react-native-image-slider-box";
import persianDate from 'persian-date';

const size =  Dimensions.get('window').width / 5 -40;
const imageHeight =Dimensions.get('window').width *9 / 16;

const TimeStamp = props => {
  return(
    <View style={{flexDirection:'row'}}>
      <IconButton icon='clock-outline' style={{margin:-7, marginHorizontal:0}}/>
      <View style={{width:55}}>
      <TextTicker
          style={{fontFamily:'iransans',fontSize:11,marginTop:2 }}
          duration={3000}
          loop
          bounce
          repeatSpacer={50}
          marqueeDelay={1000}
          isRTL={true}
        >
        {props.start} تا {props.end}
        </TextTicker>
        </View>
    </View>
  )
}

const sportIcons = { 
  
  "اسپینینگ":
  require("../assets/sportsicons/spin.png"),

  "ایروبیک":
  require("../assets/sportsicons/rhytm.png"),

  "بدنسازی":
  require("../assets/sportsicons/gym.png"),

  "تمرینات فانکشنال / کراسفیت":
  require("../assets/sportsicons/cf.png"),

  "تمرینات لس میلز":
  require("../assets/sportsicons/bp.png"),

  "تمرینات معلق":
  require("../assets/sportsicons/trx.png"),

  "جامپینگ فیتنس":
  require("../assets/sportsicons/jump.png"),

  "فیتنس":
  require("../assets/sportsicons/fit.png"),

  "دوچرخه سواری":
  require("../assets/sportsicons/bike.png"),

  "ورزش های آبی":
  require("../assets/sportsicons/swim.png"),

  "ورزش های آزاد":
  require("../assets/sportsicons/free.png"),

  "ورزش کودکان":
  require("../assets/sportsicons/kids.png"),

  "کیک بوکس / رزمی":
  require("../assets/sportsicons/kb.png"),

  "یوگا پیلاتس":
  require("../assets/sportsicons/yoga.png"),

  "متفرقه":
  require("../assets/sportsicons/other.png"),

} ;

const circles = [

  {   
    color:'#feb9b9',
    str: 'قدرت'
  },
  {   
   color:'#90f5fd',
   str: 'انعطاف'
  },
  {   
   color:'#d387ee',
   str: 'هوازی'
  },
  {   
   color:'#8d74cb',
   str: 'تعادل'
  },
  {   
   color:'#fcbf82',
   str: 'شدت'
  }
 
 ]

export default class App extends React.Component {
  state = {
     mainScrollEnabled : true,
     liked : global.favorites[global.activeClassInfo.classid],
     results: [] ,
     submitCommentVisible : false,

     data : {
      images : [],
			classid : null,
			classlevel : 0,
			capacity : null,
      trainername : null,
      trainerimage : null,
			trainerdescription : null,
			classelements : [	0,0,0,0,0,],
			description : null,
			commentscount : [	0,0,0,0,0,],
			facilities : {
				parking : false,
				locker : false,
				towel : false,
				pool : false,
      },
			cancelingterms : null,
			preparation : null,
			address : null,
      map : null,
      similar_classes:[]
     },

     Comments : null,
     page :1,
     loadingMore: true,
     refreshing: false,

     commentExpanded:false,

     userRate: 5,

     connectionToast: false
   
  };

  componentDidMount(){
    fetch('https://fitwayz.ir/api/classes/info',
    {
      method:'POST',
      withCredentials: true,
       
      headers:{
        Accept: 'application/json',
        Authorization: 'Bearer ' + global.token,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id : global.activeClassId,
      })
    })
    .then(response => response.json()).then(responseJson => {
      console.log(responseJson);
      global.acDate= new persianDate(Date.parse(responseJson.date))
      this.setState({data : responseJson});
    })
    .catch(error => {
      this.setState({connectionToast:true})
    });



  }

  _showModal = () => this.setState({ submitCommentVisible: true });
  _hideModal = () => this.setState({ submitCommentVisible: false });


  _shareText() {
    Share.share({
      message: 'سلام، بریم کلاس ' +global.activeClassInfo.classname +' باشگاه '+global.activeClassInfo.gymname+' که روی اپلیکیشن "فیت ویز" پیدا کردم ورزش کنیم؟'+' '+'fitwayz.ir',
    }, {
      dialogTitle: 'به اشتراک گذاری کلاس',
  
      tintColor: 'green'
    })
    .then(this._showResult)
    .catch((error) => this.setState({result: 'error: ' + error.message}));
  }

  _showResult(result) {
    if (result.action === Share.sharedAction) {
      if (result.activityType) {
        this.setState({result: 'shared with an activityType: ' + result.activityType});
      } else {
        this.setState({result: 'shared'});
      }
    } else if (result.action === Share.dismissedAction) {
      this.setState({result: 'dismissed'});
    }
  }



  static navigationOptions = {
    header : null,
  };


  render() {
    var sliderImages=this.state.data.images.map((item)=>{ return item.replace('http','https') });
    const isDone=this.props.route.params?.done;
    console.log(this.state.data.classlevel);
    return (

      <View style={{height:Dimensions.get('window').height, backgroundColor:'white'}}>
        <Appbar.Header style={{height:50,backgroundColor:'white'}} >
        
             <Appbar.Action icon="share-variant" color='#3a3635' onPress={this._shareText} />
             <Appbar.Action icon={(this.state.liked)? "heart" :"heart-outline"} color='#3a3635' onPress={() => {
               if(this.state.liked){
                fetch('https://fitwayz.ir/api/users/favorites/'+global.activeClassInfo.id+'/remove',
                {
                  method:'POST',
                  withCredentials: true,
                   
                  headers:{
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + global.token,
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify([])
                })
                .then(response => response.json()).then(responseJson => {
                  console.log(responseJson);
                  global.favorites[global.activeClassInfo.classid] = undefined;
                  this.setState({liked:!this.state.liked});
                })
                .catch(error => {
                  this.setState({connectionToast:true})
                });

               } else {

                fetch('https://fitwayz.ir/api/users/favorites/'+global.activeClassInfo.id+'/add',
                {
                  method:'POST',
                  withCredentials: true,
                   
                  headers:{
                    Accept: 'application/json',
                    Authorization: 'Bearer ' + global.token,
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify([])
                })
                .then(response => response.json()).then(responseJson => {
                  console.log(responseJson);
                  global.favorites[global.activeClassInfo.classid] = true;
                  this.setState({liked:!this.state.liked});
                })
                .catch(error => {
                  this.setState({connectionToast:true})
                });
                 
               }

               
             }} />
             <Appbar.Action style={{marginLeft:'auto'}} icon="arrow-left" color='#3a3635' onPress={() => {this.props.navigation.goBack()}} />

           </Appbar.Header>

      <ScrollView scrollEnabled={this.state.mainScrollEnabled}>

      <SliderBox resizeMode={'cover'} sliderBoxHeight={imageHeight} images={sliderImages} />

{/*       <Swiper style={styles.wrapper} showsButtons={false} activeDotColor='#2ebbc4' key={this.state.data.images.length} loop={false} paginationStyle={{bottom:5}}>
        
        {
          this.state.data.images.map((value,index) => {
            return(
              <View key={index} style={styles.slide}>
                <Image style={{ position:'absolute', top :0 , left :0, zIndex:-10, width:imgW, height:imageHeight }} resizeMode='cover' source={{uri : value}} />
              </View>
            )
          })
        }
       
      </Swiper> */}
     


<View style={{backgroundColor:'#21706c'}}> 
<View style={{flexDirection:'row',alignItems:'center',marginHorizontal:16}}>
    <Avatar.Image style={{backgroundColor:'#21706c'}} size={35} source={sportIcons[global.activeClassInfo.sport]} />
    <Text style={{marginHorizontal:7,fontSize:18,color:'white', marginTop:4 }}>{global.activeClassInfo.classname}</Text>
  </View>
<View style={{flexDirection:'row',alignItems:'center',justifyContent:'space-between',paddingHorizontal:20}}>
  <View>
    <View style={{flexDirection:'row'}}>
      <Text style={{  marginBottom:2,color:'white',fontSize:12}}>باشگاه {global.activeClassInfo.gymname}</Text>
      <Text style={{color:'white',fontSize:12}}> / ظرفیت : {this.state.data.capacity}</Text>
    </View>
    <Text style={{ marginBottom:4,color:'white',fontSize:12}}>{global.acDate.toLocale('fa').format('dddd')+ ' ' + global.acDate.date()+ ' ' + global.acDate.toLocale('fa').format('MMMM')} ساعت {global.activeClassInfo.starttime} الی {global.activeClassInfo.endtime}</Text>
  </View>
  <View style={{flexDirection:'row',alignItems:'center'}}>
    <IconButton icon='card-bulleted-outline' color='white' style={{marginHorizontal:0}} />
    <View>
    <Text style={{marginLeft:'auto',textDecorationLine:'line-through',color:'#ffc7d3',fontSize:12,display:(global.activeClassInfo.broken_price == null || global.activeClassInfo.broken_price == 0) ? 'none' :'flex' }}>{global.activeClassInfo.broken_price}</Text>
    <Text style={{color:'white',fontSize:12}}>{global.activeClassInfo.price} تومان</Text>
    </View>
  </View>
</View>
  
</View>


<View style={styles.divider}>
<Text style={{ color:'#3a3635' }}>مربی</Text>
</View>
<View style={{flexDirection:'row',padding:4, paddingHorizontal:10}}>
  <View style={{marginHorizontal:6 ,marginTop:10,marginBottom:10}}><Avatar.Image size={50} source={{uri : this.state.data.trainerimage}}  /></View>

<View style={{flex:1, marginLeft:10}}>
<Text style={{ color:'#3a3635'}}>{global.activeClassInfo.trainer}</Text>
<Text style={{marginVertical:2,fontSize:12, color:'#3a3635'}}>{this.state.data.trainerdescription}</Text>

</View>

</View>






<View style={styles.divider}>
<Text style={{ color:'#3a3635'}}>توضیح ورزش</Text>
</View>


  <Text style={{marginHorizontal:20, marginTop:6, marginBottom:6 , color:'#3a3635',fontSize:12}}>{this.state.data.description}</Text>


  <View style={{flexDirection:'row',paddingHorizontal:10,marginLeft:'auto',marginRight:'auto' }}>

{this.state.data.classelements.map((item,index) => { return(
  <View style={{justifyContent:'center',alignItems:'center'}}>
  <View key={index} style={{flexDirection:'row',width:size,height:size,borderColor:circles[index].color,borderWidth:3,borderRadius:size/2, marginBottom:4,marginHorizontal:10,justifyContent:'center',alignItems:'center',paddingTop:5}}>
   
    <Text style={{fontSize:10}}>/10</Text>
    <Text style={{fontSize:20}}>{item}</Text>
  </View>
  <Text style={{marginBottom:4,fontSize:11}}>{circles[index].str}</Text>
  </View>
)
})}

</View>




<View style={styles.divider}>
<Text style={{ color:'#3a3635'}}>دیدگاه کاربران</Text>
</View>

 {global.activeClassInfo.avgrate == null ?
  <Text style={{marginHorizontal:20,marginTop:4 ,fontSize:12, color:'#3a3635'}}>هنوز دیدگاهی برای این کلاس ثبت نشده است</Text>
  :
  <View style={{flexDirection:'row',paddingHorizontal:20}}>
       <Rating
            type='star'
            readonly={true}
            ratingColor="#3a3635"
            imageSize={14}
            startingValue={global.activeClassInfo.avgrate}
            style={{marginTop:6}}
        />
       <Text style={{marginHorizontal:6,marginTop:4 ,fontSize:12, color:'#3a3635'}}>{global.activeClassInfo.avgrate} از 5 بر اساس {this.state.data.commentscount[0]+this.state.data.commentscount[1]+this.state.data.commentscount[2]+this.state.data.commentscount[3]+this.state.data.commentscount[4]} رای</Text>

</View>
}
<Button dark theme={{colors:{primary:'#2ebbc4'}}} disabled={global.activeClassInfo.avgrate == null} mode='contained' onPress={() => {
this.props.navigation.push('Comments',{uri : this.state.data.trainerimage})
}} 
style={{marginLeft:'auto',marginRight:'auto',marginTop:4,marginBottom:12,borderRadius:15}} contentStyle={{height:30}} >مشاهده دیدگاه ها</Button>


<View style={styles.divider}>
<Text style={{ color:'#3a3635'}}>شرایط ورود به کلاس</Text>
</View>
  <Text style={{marginHorizontal:20, marginTop:6, marginBottom:6 , color:'#3a3635',fontSize:12}}>{this.state.data.preparation}</Text>


<View style={styles.divider}>
<Text style={{color:'#3a3635'}}>شرایط لغو رزرو</Text>
</View>
  <Text style={{marginHorizontal:20,  marginTop:6, marginBottom:6 , color:'#3a3635',fontSize:12}}>{this.state.data.cancelingterms}</Text>



<View style={styles.divider}>
<Text style={{color:'#3a3635'}}>آدرس</Text>
</View>
<Text style={{ marginTop:6,marginHorizontal:20,color:'#3a3635',fontSize:12}}>{global.activeClassInfo.address}</Text>

{this.state.data.classlevel != 'پیشرفته' &&
<View style={{ height: Dimensions.get('window').width *9/16, width:Dimensions.get('window').width-40 ,overflow:'hidden',marginRight:'auto',marginLeft:'auto',marginBottom:10,marginTop:15,borderRadius:6,borderColor:'grey',borderWidth:0.3}}>
  <WebView
    originWhitelist={["*"]}
    source={{html: this.state.data.map}}
    scalesPageToFit={true}
    
    
  />
<IconButton icon={(this.state.mainScrollEnabled)? "lock-open-outline" : "lock"} color='#3a3635' size={18} style={{position:'absolute',top:0,left:0,margin:2}} onPress={() =>{this.setState({mainScrollEnabled:!this.state.mainScrollEnabled})}} />
</View>
}

<View style={{height:10}}></View>

<View style={styles.divider}>
<Text style={{color:'#3a3635'}}>کلاس های مشابه</Text>
</View>

<ScrollView contentContainerStyle={{paddingVertical:15,paddingHorizontal:20}} horizontal={true}>
{this.state.data.similar_classes.map((item,index)=>{
                   return(
                    <Card key={index} style={{width:270,elevation:5,marginHorizontal:5}}
                    onPress={()=>{
                      global.activeClassId = item.id;
                      global.activeClassInfo = item;
                      this.props.navigation.popToTop();
                      this.props.navigation.push('Class')}}>
                    <Card.Title subtitleStyle={{marginRight:20}} titleStyle={{marginRight:20}} subtitle={item.gymname}  title={item.classname} left={props => <Avatar.Image {...props} style={{backgroundColor:'#21706c'}} size={48} source={sportIcons[item.sport]} />} />
                    <Card.Content>
                      <View style={{flexDirection:'row', justifyContent:'space-between'}}>
                        <View style={{flexDirection:'row'}}>
                        <IconButton icon='human' style={{margin:-7,}}/>
                          <Text numberOfLines={1} style={{maxWidth:125,marginHorizontal:5}}>{item.trainer}</Text>
                        </View>
                        <TimeStamp start={item.starttime} end={item.endtime}/>
                      </View>
                      <Divider style={{marginVertical:15}} />
                      <View style={{flexDirection:'row'}}>
                        <IconButton icon='map-marker-outline' style={{margin:-7}}/>
                        <Text numberOfLines={1} style={{maxWidth:200,marginHorizontal:5}}>{item.address}</Text>
                      </View>
                    </Card.Content>
                    </Card>
                   )
                 })}
               </ScrollView>




<View style={{height:65}}></View>



      </ScrollView>

      
      <Portal>
       <Modal visible={this.state.submitCommentVisible} onDismiss={this._hideModal}>
         <View style={{backgroundColor:'white', marginHorizontal:20, borderRadius:5, overflow:'hidden', paddingHorizontal:20,paddingVertical:40}}>
         <Text style={{marginLeft:15}}>دیدگاهتان درباره این کلاس را به اشتراک بگذارید</Text>
  
         <Rating
           type='star'
           imageSize={30}
           startingValue={this.state.userRate}
           style={{marginTop:15 , marginLeft:'auto', marginRight:'auto'}}
           onFinishRating={(value) => this.setState({userRate: value}) }
         />

          <Text style={{marginLeft:'auto', marginRight:'auto', fontSize: 16,marginTop:4}}>امتیاز : {this.state.userRate}</Text>

           <TextInput
              theme={{colors:{primary:'#2ebbc4',}}}
              style={styles.inputContainerStyle}
              label="متن دیدگاه"
              value={this.state.userComment}
              onChangeText={comment => this.setState({ userComment: comment })}
              selectionColor='#c4fbff'
              multiline={true}
              numberOfLines={6}
              mode='outlined'
            />

           <Button mode='contained' dark={true} style={styles.button1} color='#2ebbc4' disabled={this.state.buttonDisabled}
             onPress={() => {

                 fetch('https://fitwayz.ir/api/classes/'+global.activeClassInfo.id+'/comment',
                 {
                   method:'POST',
                   headers: {
                     Accept: 'application/json',
                     Authorization: 'Bearer ' + global.token,
                     'Content-Type': 'application/json',
                   },
                   body: JSON.stringify({
                     rate: this.state.userRate,
                     content: this.state.userComment
                   })
                 }).then(response => response.json()).then(responseJson => {
                      console.log(responseJson);
                      if (responseJson.result == 'success'){
                        this.setState({submitCommentVisible:false,toastVisible:true, toast:'دیدگاه شما با موفقیت ثبت شد'})
                      } else{
                        this.setState({submitCommentVisible:false,toastVisible:true, toast:'در حال حاضر امکان ثبت دیدگاه وجود ندارد'})
                      }
                      })
                      .catch(error => {
                        this.setState({connectionToast:true})
                      });

               this.setState({buttonDisabled : true});
             }
            } 
            contentStyle={{width:170,height:46}}>ثبت دیدگاه</Button>


         </View>
       </Modal>
     </Portal>

      {isDone?
            <FAB
            label="نظر سنجی"
            color="#FFF"
            style={styles.fab3}
            onPress={() => {
              this._showModal();
            }}
          />
      :
      <FAB
      label="رزرو کلاس"
      color="#FFF"
      style={styles.fab3}
      onPress={() => {
        this.props.navigation.navigate('Invoice')
      }}
    />
      }

      
       <Snackbar
          style={{zIndex:200}}
          visible={this.state.connectionToast}
          onDismiss={() => this.setState({connectionToast:false})}>
         ارتباط اینترنت با مشکل مواجه است
        </Snackbar>


   
   </View>
      
     
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#fff',
    alignItems: 'center',
    justifyContent: 'center',
  },
  divider:{
    backgroundColor :'#fff',
    padding:4,
    marginHorizontal:20,
    borderColor:'grey',
    borderTopWidth:0.3
  },
  fab3: {
    width:170,
    alignSelf: 'center',
    position: 'absolute',
    bottom: 0,
    margin: 8,
    backgroundColor:'#2ebbc4'
  },
  wrapper: {height:imageHeight
  },
  slide: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
  },
  text: {
    color: '#fff',
    fontSize: 30,
    fontWeight: 'bold',
  },
  inputContainerStyle: {
    marginHorizontal:10,
    backgroundColor:'white',
    marginTop:15
  },
  button1:{
    marginLeft:'auto',
    marginRight:'auto',
    borderRadius:23,
    marginTop:30,
  },
});
